import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
// @mui
import { Stack, TextField, Button, ButtonGroup } from '@mui/material';
import { getPost, updatePost, createPost } from '../../services/Common/post.service';
import { toast } from 'react-toastify';


export default function PostForm({ edit }) {
    const [formData, setFormData] = useState({
        title: '',
        description: '',
        image: ""
    })
    const [existingImage, setExistingImage] = useState(null);

    const { title, description, image } = formData

    const navigate = useNavigate();
    const { id } = useParams();

    useEffect(() => {
        if (edit && id) {
            const fetchPost = async () => {
                try {
                    const res = await getPost(id);
                    const post = res?.data?.data || res?.data || res;
                    setFormData(prev => ({
                        ...prev,
                        title: post?.title || '',
                        description: post?.description || '',
                    }));
                    if (post?.image) {
                        setExistingImage(post.image);
                    }
                } catch (e) { console.error('Failed to load post:', e) }
            };
            fetchPost();
        }
    }, []);

    const handleChange = (e) => {
        if (e.target.name === "image") {
            setFormData({ ...formData, [e.target.name]: e.target.files[0] })
            return
        }
        setFormData({ ...formData, [e.target.name]: e.target.value })
    }

    const handleSubmit = async () => {
        const data = new FormData()
        data.append('title', title)
        data.append('description', description)
        data.append('image', image)
        if (edit) {
            const res = await updatePost(id, data)
            toast.success("Post updated successfully")
            navigate("/post")
            return
        }
        const res = await createPost(data)
        toast.success("Post created successfully")
        navigate("/post")
    }

    return (
        <Stack spacing={3}>
            <TextField
                name="title"
                value={title}
                onChange={handleChange}
                label="Title"
            />
            <TextField
                name="description"
                value={description}
                onChange={handleChange}
                label="Description"
            />
            {existingImage && (
                <div style={{ marginBottom: 16 }}>
                    <img src={existingImage} alt="Current" style={{ maxWidth: 300, maxHeight: 200, borderRadius: 8, border: '1px solid #ccc' }} />
                    <p style={{ fontSize: 12, color: '#888', marginTop: 4 }}>Current image (select new to replace)</p>
                </div>
            )}
            <TextField
                name="image"
                type="file"
                onChange={handleChange}
                label="Image"
            />
            <ButtonGroup>
                <Button
                    variant="contained"
                    onClick={handleSubmit}
                >Submit</Button>
                <Button
                    variant="outlined"
                    color='secondary'
                    onClick={() => navigate("/post")}
                >Go Back</Button>
            </ButtonGroup>
        </Stack>
    );
}
